module.exports = __webpack_public_path__ + "static/media/photo94.047fb84e.jpg";